import {
  outcomeMeta,
  fmtNumber,
  fmtPercent,
} from "./shared";
import { colors } from "../../global";

export const OverviewSection = ({ general_information }) => {
  const initial = general_information?.initial_offering ?? 0;
  const optimized = general_information?.optimised ?? 0;
  const meta = outcomeMeta(initial, optimized);

  const displayPct =
    typeof general_information?.percentage_reduction_incumbent_cora === "number"
      ? general_information.percentage_reduction_incumbent_cora
      : meta.pct;

  const absSavings = initial - optimized;
  const datasetCoverageDesc = `${fmtPercent(
    general_information?.percentage_cons_priced
  )} of consignments priced`;

  const optimizedLabel = meta.label;
  const optimizedBadge = meta.badge;
  const optimizedAccent = meta.accent;

  const isOpportunityPositive = absSavings > 0;
  const opportunityTitle = isOpportunityPositive
    ? "Potential Savings"
    : absSavings === 0
    ? "No Opportunity"
    : "Additional Cost";
  const opportunityDesc = isOpportunityPositive
    ? "Total opportunity identified"
    : absSavings === 0
    ? "No savings or loss"
    : "Extra cost vs incumbent";
  const opportunityAccent = isOpportunityPositive
    ? colors.success
    : absSavings === 0
    ? colors.info
    : colors.error;

  return (
    <>
      {/* Header */}
      <div className="w-full px-6 py-12">
        <div className="mx-auto text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Logistics Cost Analysis Results
          </h1>
          <p className="text-gray-600 text-lg mb-6">
            Analysis Period: {general_information?.date_range}
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            {general_information?.most_common_dispatch_zone && (
              <span className="rounded-full border border-gray-300 px-4 py-2 bg-gray-100 text-gray-700">
                Primary Zone:{" "}
                <span className="font-semibold text-gray-900">
                  {general_information?.most_common_dispatch_zone}
                </span>
              </span>
            )}
            <span className="rounded-full border border-gray-300 px-4 py-2 bg-gray-100 text-gray-700">
              Carriers Analyzed:{" "}
              <span className="font-semibold text-gray-900">
                {fmtNumber(general_information?.count_unique_list_carrier)}
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
